export default __webpack_public_path__ + "static/media/tog.bf19f203.svg";